"use client";

import { createContext, useContext } from "react";

export interface BrandingContextValue {
  appName: string;
  logoUrl: string | null;
}

const BrandingContext = createContext<BrandingContextValue>({
  appName: "OmniDialer",
  logoUrl: null,
});

export function BrandingProvider({
  value,
  children,
}: {
  value: BrandingContextValue;
  children: React.ReactNode;
}) {
  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding(): BrandingContextValue {
  return useContext(BrandingContext);
}
